'use client';

import { useClientTranslation } from '@bts-web/utils-lokalise';
import { TFunction } from 'i18next';
import { getTradeAssetSelectorTranslations } from '../../ChangeCurrencyOrSwap/changeCurrencyUtils';
import { useFiatTransactionFee } from './useFiatTransactionFee.use-client';
import { useFiatWallet } from './FiatWalletContext.use-client';
import { FeesForAmount } from './FeesForAmount';
import { FeesForAmountSkeleton } from './FeesForAmountSkeleton';

interface FiatFeesSectionProps {
  amountInput: string;
  currency: string;
  locale: string;
  minimumAmount: string;
}

export const FiatFeesSection = ({
  amountInput,
  currency,
  locale,
  minimumAmount,
}: FiatFeesSectionProps) => {
  const { t } = useClientTranslation();

  const translations = getTradeAssetSelectorTranslations(t as TFunction);

  const { fee, isLoading, hasError } = useFiatTransactionFee(
    amountInput,
    'DEPOSIT',
    minimumAmount,
  );

  const { data: walletData } = useFiatWallet();

  const feesAmount = Number(amountInput.replace(',', '.'));

  const feesFee = Number(fee) || 0;

  const walletBalance = Number(walletData?.walletAmount ?? 0);

  if (feesAmount === 0 || hasError) return null;

  if (isLoading) return <FeesForAmountSkeleton />;

  const depositNeeded = feesAmount > walletBalance;

  if (!depositNeeded) {
    return (
      <FeesForAmount
        totalLabel={translations.total}
        total={feesAmount}
        currency={currency}
        locale={locale}
      />
    );
  }

  return (
    <FeesForAmount
      lineItems={[{ label: translations.onlineTransferFee, value: feesFee }]}
      totalLabel={translations.total}
      total={feesAmount + feesFee}
      currency={currency}
      locale={locale}
    />
  );
};
